import React, { useEffect, useState } from "react";
import { Card, Grid, IconButton, Skeleton, Tooltip } from "@mui/material";
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';

import ShowDeliveryMethod from './showDeliveryMethod';
import { useDisapprovalReasons } from '../../customHooks/useDisapprovalReasons';
import { toStdDate } from "../../utils/dates";

export default function PendingBuyNotApproved({ buyRequest, event, swarm, onCloseClick }) {
  const { disapprovalReasons } = useDisapprovalReasons();

  const cardInfo = () => {
    return (
      {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
        alignItems: 'flex-start',
        margin: "0 0 0.5em 0"
      }
    );
  }

  const ReasonStyles = () => {
    return (
      {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row' },
        alignItems: 'flex-start',
        margin: '0'
      }
    );
  }

  let BuyRequestDissaprovalReason = disapprovalReasons?.find(DR => DR.id == buyRequest?.reasonId)

  const isMobile = useIsMobile();
  
  function useIsMobile(breakpoint = 600) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  let title = !event?.name ? "Error on Event Data" : `${event?.name} - ${event?.venue?.name + ", " + event?.venue?.city} - ${event ? toStdDate(event.date) : 'Null'}`;

  let mobileTitle = !event?.name ? "Error on Event Data" : `${event?.name?.substring(0, 20)} - ${event?.venue?.name?.substring(0, 20) + ", " + event?.venue?.city} - ${event ? toStdDate(event.date) : 'Null'}`;
  return (
    <Card sx={{ margin: '0  0 2em 0', borderRadius: '1.5em', padding: '1em 1em 0.5em 1em' }} >

      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>

        <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }} >
          <h4 style={{ fontWeight: '600', color: 'var(--orange)', margin: '0 0 0.5em 0 ', width: "100%" }} >
            {
              !event
                ?
                <Skeleton variant="text" width="50%" ></Skeleton>
                :
                <Tooltip title={title} placement="top" enterTouchDelay={0}>
                  <span>{isMobile ? mobileTitle : title}</span>
                </Tooltip>            
            }
          </h4>
          <IconButton onClick={() => onCloseClick(buyRequest)} >
            <CloseOutlinedIcon color="primary" />
          </IconButton>
        </Grid>

        <Grid item sx={cardInfo} >

          <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', margin: '0 2em 0 0' }} >
            <ConfirmationNumberOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
            <p style={{ fontWeight: '700', margin: '0.15em 0 0 0' }} >{`${buyRequest.quantity} tickets in Section ${buyRequest.section} - Row ${buyRequest.row} - Seats ${buyRequest.seats}`}</p>
          </Grid>

          <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
            <InboxOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
            <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} > <ShowDeliveryMethod deliveryMethodID={buyRequest.deliveryMethodID} /></p>
          </Grid>

          <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', margin: '0 2em 0 0' }} >
            <SellOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
            <p style={{ fontWeight: '700', whiteSpace: 'nowrap', margin: '0.15em 0 0 0' }} >Total Cost ${buyRequest.totalCost}</p>
          </Grid>

          {
            buyRequest.isLimitedView &&
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
              <VisibilityOffOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Obstructed/Limited View</p>
            </Grid>
          }

          <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
            <PaidOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
            <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Reward {`$${buyRequest?.swarmRewardTypeId === 1 ? (buyRequest?.rewardAmout / buyRequest?.quantity) : buyRequest?.rewardAmout} ${buyRequest?.swarmRewardTypeId === 1 ? `Per Ticket` : `Total`}`}</p>
          </Grid>

        </Grid>

        <Grid item sx={ReasonStyles} >

          <Grid item sx={{ margin: '0 2em 0.5em 0' }}>
            <h4 style={{ fontWeight: '700', color: 'white', whiteSpace: 'nowrap', backgroundColor: 'var(--red)', padding: '0.35em 0.75em', borderRadius: '8px' }} >
              NOT APPROVED
            </h4>
          </Grid>

          <Grid item sx={{ margin: '0 0 0.5em 0', width: '100%' }}>
            <p style={{ margin: "0" }}>
              {
                BuyRequestDissaprovalReason?.name
              }
            </p>
          </Grid>

        </Grid>

      </Grid>

    </Card>
  )
}